import { api, ApiRes } from './client'

export interface KeycloakCredentialResponse {
    type: string
    category: string
    displayName: string
    helptext: string
    iconCssClass: string
    createAction?: string
    updateAction?: string
    removeable: boolean
    userCredentialMetadatas: Array<KeycloakCredentialMetadata>
}

export interface KeycloakCredentialMetadata {
    credential: {
        id: string // uuid
        type: string
        createdDate: number
        credentialData: string
    }
}

export const getKeycloakCredentialsForNaturalProfile = (naturalProfileUid): ApiRes<KeycloakCredentialResponse[]> =>
    api.get(`natural-profiles/${naturalProfileUid}/credentials`)

export const deleteKeycloakCredential = (naturalProfileUid, credentialId): ApiRes<undefined> =>
    api.delete(`natural-profiles/${naturalProfileUid}/credentials/${credentialId}`)
